import { createDataLoader } from '../utilities/create-data-loader';
import { createApiClient } from '../api/client';
import { USER_API_PATHS } from '../constants/api';
import { getUserDisplayName } from '../utilities/user-utils';
import { useIdResolver, useIdResolverPrefetch } from './useIdResolver';

export const USER_DISPLAY_NS = 'user-display';
const NS = USER_DISPLAY_NS;

const pickUsername = user => user?.username || user?.email || getUserDisplayName(user?._id || user?.id);
const pickFullname = user => user?.fullname || user?.display_name || user?.name;

const batchFetch = async ids => {
  const { data } = await createApiClient().post(USER_API_PATHS.LIST, { user_ids: ids });
  const users = data?.response?.user || [];
  const byId = new Map();
  users.forEach(u => {
    const key = u._id || u.id;
    if (!key) return;
    byId.set(key, { username: pickUsername(u), fullname: pickFullname(u) });
  });
  ids.forEach(id => {
    if (!byId.has(id)) byId.set(id, { username: getUserDisplayName(id), fullname: undefined });
  });
  return byId;
};

export const userDisplayLoader = createDataLoader({ batchFetch });
const loader = userDisplayLoader;

export const useUserDisplay = id =>
  useIdResolver({
    ns: NS,
    id,
    loader,
    select: data => data ?? { username: getUserDisplayName(id), fullname: undefined }
  });

export const useUserDisplayPrefetch = () => useIdResolverPrefetch({ ns: NS, loader });
